module.exports = __webpack_public_path__ + "static/img/pay-ios.c59963a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay-ios.png
// module id = HQuh
// module chunks = 1